import Api from "../axios";

export const postRejectTaskboardLeave = async ({ id }) => {
  return await Api.post("/reject_taskboard_leave", {
    application_id: id,
  });
};
